import { Component } from '@angular/core';

@Component({
    selector: 'app-user-table',
    templateUrl: './user-table.component.html',
    styleUrls: ['./user-table.component.scss'],
    standalone: false
})
export class UserTableComponent {

}
